<h5>Proof of Identity</h5>
<form
    name="proof-of-identity-form"
    [formGroup]="registrationForm"
    (ngSubmit)="onSubmit()"
>
    <div class="form-container">
        <div
            class="row"
            style="margin-bottom: 20px;"
        >
            <div class="col-12">
                <span class="required fa fa-asterisk"></span> Indicates required field
            </div>
        </div>
        <div class="row">
            <div class="col-12 col-sm-6">
                <div class="form-group">
                    <label for="select-country">Country of Citizenship (Country Issuing Passport) <span class="required fa fa-asterisk"></span> </label>
                    <select
                        class="custom-select"
                        formControlName="countryId"
                        name="countryId"
                        [ngClass]="{ 'is-invalid': submitted && f.countryId.errors }"
                    >
                        <option value="null">Select a country</option>
                        <option
                            *ngFor="let opt of personalLookupInfo.countries"
                            [value]="opt.id"
                        >{{opt.name}}</option>
                    </select>
                </div>

                <div class="form-group">
                    <label for="input-first-name">First | Given Name <span class="required fa fa-asterisk"></span> </label>
                    <input
                        type="text"
                        class="form-control"
                        id="input-first-name"
                        formControlName="firstName"
                        name="firstName"
                        [ngClass]="{ 'is-invalid': submitted && f.firstName.errors }"
                    />
                </div>

                <div class="form-group">
                    <label for="input-middle-name">Middle Name</label>
                    <input
                        type="text"
                        class="form-control"
                        id="input-middle-name"
                        formControlName="middleName"
                        name="middleName"
                        [ngClass]="{ 'is-invalid': submitted && f.middleName.errors }"
                    />
                </div>

                <div class="form-group">
                    <label for="input-last-name">Last Name <span class="required fa fa-asterisk"></span> </label>
                    <input
                        type="text"
                        class="form-control"
                        id="input-last-name"
                        formControlName="lastName"
                        name="lastName"
                        [ngClass]="{ 'is-invalid': submitted && f.lastName.errors }"
                    />
                    <div class="custom-control custom-checkbox">
                        <input
                            type="checkbox"
                            class="custom-control-input"
                            id="last-name-check"
                            formControlName="skipLastName"
                            name="skipLastName"
                        >
                        <label
                            class="custom-control-label"
                            for="last-name-check"
                            style="font-weight: 500"
                        >I do not have a last name.</label>
                    </div>
                </div>

                <div class="form-group">
                    <label for="input-dob">Date of Birth <span class="required fa fa-asterisk"></span> </label>
                    <input
                        type="date"
                        class="form-control"
                        id="input-dob"
                        formControlName="dateOfBirth"
                        name="dateOfBirth"
                        [ngClass]="{ 'is-invalid': submitted && f.dateOfBirth.errors }"
                    />
                </div>
            </div>
            <div class="col-12 col-sm-6">
                <div class="form-group">
                    <label for="select-id-doc-type">Identity Document Type <span class="required fa fa-asterisk"></span>
                    </label>
                    <select
                        class="custom-select"
                        id="select-id-doc-type"
                        formControlName="documentTypeId"
                        name="documentTypeId"
                        (change)="idDocTypeUpdated()"
                        (blur)="checkRefugeeClaimant()"
                        [ngClass]="{ 'is-invalid': submitted && f.documentTypeId.errors }"
                    >
                        <option></option>
                        <option
                            *ngFor="let opt of personalLookupInfo.idDocTypes"
                            [value]="opt.id"
                        >{{opt.name}}</option>
                    </select>
                    <p *ngIf="showBNOPassportWarning">Please note that the British National (Overseas) Passport is NOT accepted for the CELPIP Test.</p>
                    <div class="custom-control custom-checkbox">
                        <input
                            type="checkbox"
                            class="custom-control-input"
                            id="id-doc-check"
                            formControlName="documentConfirm"
                            name="documentConfirm"
                            [ngClass]="{ 'is-invalid': submitted && f.documentConfirm.errors }"
                        >
                        <label
                            class="custom-control-label"
                            style="font-weight: 500;"
                            for="id-doc-check"
                        >I agree to present this identity document on the
                            test day for entry. <span class="required fa fa-asterisk"></span>
                        </label>
                    </div>
                    <div
                        class="form-group"
                        *ngIf="f.documentTypeId.value == IdDocTypeEnum.CanadianTravelDocument"
                    >
                        <!-- Travel Document Note -->
                        <article
                            class="bg-policy"
                            style="padding: 1em;"
                        >
                            A Travel Document refers to the following documents specifically:
                            <ul>
                                <li>Refugee Travel Document</li>
                                <li>Travel Document in lieu of passport</li>
                                <li>Certificate of Identity</li>
                            </ul>
                            It does NOT refer to the following, and these are not accepted for the {{brandName}} Test:
                            <ul>
                                <li>NEXUS Card</li>
                                <li>Work Permit</li>
                                <li>Record of Landing</li>
                                <li>Interim Federal Health Certificate of Eligibility</li>
                                <li>Enhanced Driver's License</li>
                            </ul>
                        </article>
                    </div>
                    <div
                        class="form-group"
                        *ngIf="f.documentTypeId.value == IdDocTypeEnum.CertificateofIdentity"
                    >
                        <article
                            class="bg-policy"
                            style="padding: 1em;"
                        >
                            A certificate of identity is the name of a specific document issued by a country to non-citizens residing within their borders who are stateless persons or otherwise unable to obtain a national passport. Driver's licences and identification cards are examples of documents that are <u><strong><span style="color: #A6192E;">not</span></strong></u> certificates of identity.
                        </article>
                    </div>
                    <div
                        class="form-group"
                        *ngIf="f.documentTypeId.value == IdDocTypeEnum.ProvincialIdentificationCard"
                    >
                        <article
                            class="bg-policy"
                            style="padding: 1em;"
                        >
                            Please note that Canadian health cards are not accepted.
                        </article>
                    </div>
                    <div
                        class="form-group"
                        *ngIf="f.documentTypeId.value == IdDocTypeEnum.CertificateOfIndianStatus"
                    >
                        <article
                            class="bg-policy"
                            style="padding: 1em;"
                        >
                            Both the Secure Certificate of Indian Status and the Certificate of Indian Status will be accepted.
                        </article>
                    </div>
                    <div
                        class="form-group"
                        *ngIf="f.documentTypeId.value == IdDocTypeEnum.ChinaResidentIDCard"
                    >
                        <article
                            class="bg-policy"
                            style="padding: 1em;"
                        >
                            Please note that the Hong Kong ID Card is <strong>NOT</strong> accepted for the {{brandName}} Test.
                        </article>
                    </div>
                    <div
                        class="form-group"
                        *ngIf="this.brandId === BrandEnum.CELPIP && !isDocValidforIrcc && f.documentTypeId.value"
                    >
                        <article
                            class="bg-policy"
                            style="padding: 1em;"
                        >
                            Your CELPIP Scores <strong>cannot</strong> be used for Canadian Immigration purposes if you register with this ID.
                        </article>
                    </div>
                    <div
                        class="form-group"
                        *ngIf="this.brandId === BrandEnum.CELPIP && f.documentTypeId.value == IdDocTypeEnum.ComputerizedNationalIdentityCard"
                    >
                        <article
                            class="bg-policy"
                            style="padding: 1em;"
                        >
                            The <strong>Computerized National Identity Card (CNIC)</strong> must be a <strong>physical</strong>, <strong>valid</strong> (non-expired) card, and can only be used <strong>within Pakistan</strong>. It is not accepted for CELPIP test registration for Pakistani nationals taking the test <strong>outside of the country</strong>.
                        </article>
                    </div>
                </div>

                <div class="form-group">
                    <label for="document-number">Document Number <span class="required fa fa-asterisk"></span> </label>
                    <input
                        type="text"
                        class="form-control"
                        id="document-number"
                        formControlName="documentNumber"
                        name="documentNumber"
                        [ngClass]="{ 'is-invalid': submitted && f.documentNumber.errors }"
                    />
                </div>

                <div class="form-group">
                    <label for="expiry-date">Expiry Date <span class="required fa fa-asterisk"></span></label>
                    <input
                        type="date"
                        class="form-control"
                        id="expiry-date"
                        min="{{expiryMinDate | date:'yyyy-MM-dd'}}"
                        max="9999-12-31"
                        formControlName="documentExpiryDate"
                        name="documentExpiryDate"
                        (change)="checkExpiryDateValidity()"
                        (blur)="checkRefugeeClaimant()"
                        [ngClass]="{ 'is-invalid': submitted && f.documentExpiryDate.errors }"
                    />
                </div>

                <div class="form-group">
                    <label for="first-language">First Language <span class="required fa fa-asterisk"></span> </label>
                    <select
                        class="custom-select"
                        id="first-language"
                        formControlName="firstLanguageId"
                        name="firstLanguageId"
                        [ngClass]="{ 'is-invalid': submitted && f.firstLanguageId.errors }"
                    >
                        <option value="null">Select a language</option>
                        <option
                            *ngFor="let opt of personalLookupInfo.languages"
                            [value]="opt.id"
                        >{{opt.name}}</option>
                    </select>
                </div>

                <div class="form-group">
                    <label for="select-gender">Gender <span class="required fa fa-asterisk"></span> </label>
                    <select
                        class="custom-select"
                        id="select-gender"
                        formControlName="gender"
                        name="gender"
                        [ngClass]="{ 'is-invalid': submitted && f.gender.errors }"
                    >
                        <option></option>
                        <option value="M">Male</option>
                        <option value="F">Female</option>
                        <option value="X">X</option>
                    </select>
                </div>
            </div>
        </div>
        <div class="control-button-row">
            <button
                type="submit"
                name="confirmationYesBtn"
                class="btn btn-primary"
            >Next</button>
        </div>
        <app-modal
            #expiredRefugeeDocumentModal
            title="IDENTITY DOCUMENT APPROVAL REQUIRED"
            body="To continue with your test registration, your expired Refugee Protection Claimant Document requires preapproval by Paragon. Please email a scan or picture of your Refugee Protection Claimant Document to {{sendEmailLink}}. If your expired Refugee Protection Claimant Document is not preapproved, it will not be accepted on test-day. No refunds or transfers will be given for refused entries. Note that identity document preapproval must be requested for each test registration.  </br></br> Please allow 1 to 2 business days for Paragon to respond to your identity document preapproval request."
        >
        </app-modal>
    </div>
</form>
